import { formatAmount, parseAmount } from '../../TransferDetails/utils';

type FormatAmountWithDecimalsParameters = {
  amount: number | string;
  withDecimals: boolean;
  lang: string;
};

// format an amount depending if currency accepts decimals or not
export const formatAmountWithDecimals = ({
  amount,
  lang,
  withDecimals,
}: FormatAmountWithDecimalsParameters) => {
  const parsedAmount = parseAmount(amount, lang);
  const formattedAmount = formatAmount(parsedAmount || 0, lang, withDecimals);
  return { formattedAmount, parsedAmount };
};
